import { render } from "./IconHeart.vue?vue&type=template&id=58da24a8"
import script from "./IconHeart.vue?vue&type=script&lang=js"
export * from "./IconHeart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__